module.exports = __webpack_public_path__ + "static/media/DaciaBlock-Bold.8db402bf.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/dacia-block/DaciaBlock-Bold.eot
// module id = 764
// module chunks = 6